import React, { useState, useEffect, useCallback } from 'react';
import { fetchUsers, deleteUser } from '../../api/api';
import DataTable from '../DataTable/DataTable';
import Pagination from '../Pagination/Pagination';
import Modal from '../Modal/Modal';
import Spinner from '../../assets/spinner.svg';

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const loadUsers = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchUsers(currentPage);
      setUsers(data.results);
      setTotalPages(data.totalPages);
    } catch (err) {
      setError('Failed to fetch users.');
    } finally {
      setLoading(false);
    }
  }, [currentPage]);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);
  
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleEdit = (user) => {
    alert(`Editing is not implemented yet. Edit User ID: ${user._id}`);
  };

  const handleDeleteRequest = (id) => {
    setItemToDelete(id);
    setIsModalOpen(true);
  };
  
  const confirmDelete = async () => {
    if (itemToDelete) {
      await deleteUser(itemToDelete);
      setIsModalOpen(false);
      setItemToDelete(null);
      loadUsers();
    }
  };

  const columns = [
    { header: 'Name', accessor: 'name' },
    { header: 'Phone', accessor: 'phone' },
    { header: 'Email', accessor: 'email' },
    { header: 'Joined On', accessor: 'createdAt', isDate: true },
  ];

  if (loading) {
    return <div className="loading-spinner"><img src={Spinner} alt="Loading..." /></div>;
  }

  if (error) {
    return <div className="no-data-message">{error}</div>;
  }

  return (
    <div>
      <h1 className="page-header">User Signups</h1>
      {users.length > 0 ? (
        <>
          <DataTable 
            data={users} 
            columns={columns} 
            onEdit={handleEdit}
            onDelete={handleDeleteRequest}
          />
          <Pagination 
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        <div className="no-data-message">No users found.</div>
      )}
      <Modal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={confirmDelete}
        title="Confirm Deletion"
      >
        <p>Are you sure you want to delete this user? This action cannot be undone.</p>
      </Modal>
    </div>
  );
};

export default UsersPage;